import { Injectable } from '@angular/core';
import {HttpClient, HttpErrorResponse, HttpResponse} from '@angular/common/http';
import { parseHttpErrorBody } from '../../forms/parse-http-error-body';
import {Observable} from 'rxjs/Observable';
import {RequestParameters} from '../../models/request-parameters/parameter.model';
import {GlobalVariable} from '../../../global';
import {Subject} from 'rxjs/Subject';

@Injectable()
export class UserLogsService {
  private subject = new Subject<any>();
  constructor(private http: HttpClient) {
  }

  getLogs(parameters: RequestParameters = new RequestParameters()) {
    return this.http.get(GlobalVariable.BASE_API_URL + '/logs', {
      params: parameters.getHttpParams()
    }).map(
        (response: HttpResponse<any>) => {
          return response ;
        }
      ).catch(
        (error: HttpErrorResponse) => {
          return Observable.throw({
            code: error.status,
            body: parseHttpErrorBody(error)
          });
        }
      );
  }
}



// WEBPACK FOOTER //
// C:/Users/DENISE/Documents/IT4U/web-callcenter/src/app/shared/components/user-logs/user-logs.service.ts